import { ButtonProps, CircularProgress } from '@mui/material';
import StyledButton from './styles';

interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
}

export default function LoadingButton({
  loading, disabled, children, ...rest
}: LoadingButtonProps) {
  return (
    <StyledButton {...rest} disabled={disabled || loading}>
      <span style={{ visibility: loading ? 'hidden' : 'visible' }}>{children}</span>
      {loading && (
        <CircularProgress
          size={20}
          color="inherit"
          sx={{ position: 'absolute' }}
        />
      )}
    </StyledButton>
  );
}
